import { render, staticRenderFns } from "./fixed.vue?vue&type=template&id=f51fd3da&scoped=true&"
import script from "./fixed.vue?vue&type=script&lang=js&"
export * from "./fixed.vue?vue&type=script&lang=js&"
import style0 from "./fixed.vue?vue&type=style&index=0&id=f51fd3da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51fd3da",
  null
  
)

export default component.exports